import type { ManifestFragment } from "@/app/integration/contracts";
import { focusSocialLevels } from "@/content/focus-social";

function createPromptAudioManifest(
  level: (typeof focusSocialLevels)[number]
): ManifestFragment {
  const promptAudio = level.promptAudio;

  if (promptAudio === undefined) {
    throw new Error(level.id + " requires prompt audio");
  }

  return {
    owner: level.id,
    requirements: [
      {
        path: promptAudio,
        kind: "audio",
        levelIds: [level.id]
      }
    ]
  };
}

export const focusSocialB4AssetManifests: readonly ManifestFragment[] =
  focusSocialLevels.map(createPromptAudioManifest);

export function getFocusSocialB4AssetManifest(
  levelId: string
): ManifestFragment {
  const manifest = focusSocialB4AssetManifests.find(
    ({ owner }) => owner === levelId
  );

  if (manifest === undefined) {
    throw new Error("Missing Focus/Social asset manifest for " + levelId);
  }

  return manifest;
}
